<script setup lang="ts">
    import { ChevronDown } from 'lucide-vue-next';
    import { Button } from '@/components/ui/button';
    import {
        DropdownMenu,
        DropdownMenuContent,
        DropdownMenuItem,
        DropdownMenuLabel,
        DropdownMenuSeparator,
        DropdownMenuTrigger,
    } from '@/components/ui/dropdown-menu';
    import { VoucherStatement } from '@/types';
    import { popupCenterDual } from '@/utils/helpers';

    const props = defineProps<{
        statement: VoucherStatement;
    }>();

    const download = (fileId: number) => {
        popupCenterDual(
            route('v2.voucher.statement.file.download', {
                voucherStatementId: props.statement.id,
                fileId,
            }),
            props.statement.id.toString(),
            window.innerWidth / 2,
            window.innerHeight / 1.1,
        );
    };
</script>

<template>
    <DropdownMenu>
        <DropdownMenuTrigger as-child>
            <Button
                variant="continue"
                size="xs"
            >
                {{ $t('button-text.display-statement') }}
                <ChevronDown class="h-4 w-4" />
            </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent>
            <DropdownMenuItem
                v-for="file in statement.files_without_data"
                :key="file.id"
                @click="download(file.id)"
                class="max-w-[200px]"
            >
                <span class="w-full truncate">{{ file.original_filename }}</span>
            </DropdownMenuItem>
        </DropdownMenuContent>
    </DropdownMenu>
</template>
